import { render, staticRenderFns } from "./PartyArticleListPage.vue?vue&type=template&id=af23ab00&scoped=true"
import script from "./PartyArticleListPage.vue?vue&type=script&lang=js"
export * from "./PartyArticleListPage.vue?vue&type=script&lang=js"
import style0 from "./PartyArticleListPage.vue?vue&type=style&index=0&id=af23ab00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af23ab00",
  null
  
)

export default component.exports